export default function ServicePageFaqSection({ headingId, title, faq }) {
  const list = Array.isArray(faq) ? faq : [];
  if (!list.length) return null;

  return (
    <section
      className="mt-14 pt-12 border-t border-[#e2e6ec]"
      aria-labelledby={headingId}
    >
      <h2
        id={headingId}
        className="font-[Barlow_Condensed] font-bold uppercase tracking-tight text-[#0b1220] text-2xl sm:text-3xl mb-8"
      >
        {title}
      </h2>
      <div className="space-y-8 max-w-3xl">
        {list.map((item, idx) => (
          <div key={idx}>
            <h3 className="text-base font-bold text-[#0b1220] leading-snug">{item.q}</h3>
            <p className="mt-2 text-sm text-slate-600 leading-relaxed">{item.a}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
